import { trpc } from '@client/utils/trpc';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createWSClient, wsLink } from '@trpc/client';
import { type PropsWithChildren, useMemo } from 'react';
import SuperJSON from 'superjson';

export type TrpcProviderProps = PropsWithChildren;

const client = createWSClient({
  url: import.meta.env.VITE_API_URL,
});

export const TrpcProvider = ({ children }: TrpcProviderProps) => {
  const queryClient = useMemo(() => new QueryClient(), []);
  const trpcClient = useMemo(
    () =>
      trpc.createClient({
        transformer: SuperJSON,
        links: [
          wsLink({
            client,
          }),
        ],
      }),
    [],
  );

  return (
    <trpc.Provider client={trpcClient} queryClient={queryClient}>
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </trpc.Provider>
  );
};
